export const useDesign = () => {
  const getPrefixCls = (scope: string) => {
    return `v-${scope}`
  }

  const variables = {
    namespace: 'admin',
    elNamespace: 'el'
  }

  return {
    getPrefixCls,
    variables
  }
}